import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: localStorage.getItem("token") || null,
  email: localStorage.getItem("email") || null,
  isAuthenticated: !!localStorage.getItem("token"),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      const { token, email } = action.payload;

      if (token) {
        state.token = token;
        localStorage.setItem("token", token);
      }

      if (email) {
        state.email = email;
        localStorage.setItem("email", email);
      }

      state.isAuthenticated = !!state.token;
    },

    clearAuth: (state) => {
      state.token = null;
      state.email = null;
      state.isAuthenticated = false;

      localStorage.removeItem("token");
      localStorage.removeItem("email");
    },
  },
});

// Selecteurs
export const selectAuth = (state) => state.auth;

export const { setAuth, clearAuth } = authSlice.actions;
export default authSlice.reducer;
